// extracted by mini-css-extract-plugin
export default {"modalBg":"NftDetails_modalBg__znrsT","modal":"NftDetails_modal__88EdC","modalImage":"NftDetails_modalImage__hm1GP","modalCnt":"NftDetails_modalCnt__qYm+G"};